<div *ngIf="loaderSrv.loading$ | async" class="loader-local">
  <div class="spinner-border text-primary" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>
